import 'primeicons/primeicons.css'
import 'reflect-metadata'
import './style.css'

import Aura from '@/presets/aura'

import { CustomConfirmDialog, CustomDataTable } from '@/components'
import { primeVueComponents } from '@/components/primevue'
import { localization } from '@/plugins/localization'
import { router } from '@/router'
import * as Sentry from '@sentry/vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'
import VErrorBoundary from 'vue-error-boundary'
import App from '@/App.vue'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

const app = createApp(App)

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://3070a3c992d73e448fae08a80bc748f1@o4508839437926400.ingest.de.sentry.io/4508840354250832',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    environment: import.meta.env.PROD ? 'production' : 'local',
    // Tracing
    tracesSampleRate: 0.1,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'http://localhost:3080/', 'https://aird-ws.almaiura.it/'],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  unstyled: true,
  pt: Aura, //apply preset
})
app.use(ToastService)
app.use(DialogService)
app.use(VueQueryPlugin)
app.use(ConfirmationService)
app.use(localization)
app.component('ErrorBoundary', VErrorBoundary)
app.component('ConfirmDialog', CustomConfirmDialog)
app.component('DataTable', CustomDataTable)

for (const { name, component } of primeVueComponents) {
  app.component(name, component)
}
app.directive('tooltip', Tooltip)
app.mount('#app')
